/**
 * 手机端页面路径与pc端路径的映射
 */
export const routeMap = {
  '/detail': {// 手机版path
    targetPath: '/fullText',// pc版的path
    targetQueryMap: { // key是进入pc页面需要的参数 ; value是pc端参数名与手机端（当前）参数名的映射,即pc端的pmid参数对应当前页面的pmid参数....
      'pmid': 'pmid',
      'from': 'from'
    },
  },
  '/searchList': {
    targetPath: '/baseResult',
    targetQueryMap: {
      'key': 'inputText',
      'searchType': 'type'
    }
  },
  '/drugSearchList': {
    targetPath: '/knowledge',
    targetQueryMap: {
      'key': 'inputText',
      'searchType': 'type'
    }
  },
  '/caseReportList': {
    targetPath: '/caseList',
    targetQueryMap: {
      'key': 'inputText',
      'searchType': 'type'
    }
  },
  '/similarCase': {
    targetPath: '/similarCase',
    targetQueryMap: {
      'patientUid': 'patientUid',
      'searchType': 'type',
      'pmid': 'pmid'
    }
  },
  '/caseReportDetail': {
    targetPath: '/caseDetail',
    targetQueryMap: {
      'patientUid': 'patientUid',
      'searchType': 'type',
      'pmid': 'pmid'
    }
  },
  '/collections': {
    targetPath: '/collection',
    targetQueryMap: {}
  },
  // todo 文献总结/病例总结
}



/**
  * 根据routeMap 构建 pc ---> 手机的路径map
  */
export function createMobileRouteMap() {
  const routeMap4Mobile = {};

  Object.keys(routeMap).forEach(mobilePath => {
    const { targetPath,targetQueryMap } = routeMap[mobilePath];
    const queryMap = {};
    Object.keys(targetQueryMap).forEach(key => {
      const newKey = targetQueryMap[key];
      queryMap[newKey] = key;
    })

    routeMap4Mobile[targetPath] = {
      targetPath: mobilePath,
      targetQueryMap: queryMap
    }

  })

  return routeMap4Mobile;
 }


// WEBPACK FOOTER //
// ./src/config/routeMap.js